import { PageDefaultSegment, useAlerts } from "@sis/react-library";
import { Box, Button } from '@mui/material';
import { PageContainer } from '../../../shared/PageContainer';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { useState } from "react";
import { OtherSamplesAlertsPageInfo } from "./OtherSamplesAlertsPageInfo";

export const OtherSamplesAlertsPage = () => {

  const [showActionPerformed, setShowActionPerformed] = useState(false)
  const { alert, confirm } = useAlerts();

  const handleConfirm = () => {
    confirm('Library confirm', 'Are you sure you want to perform this action?',
      () => {
        setShowActionPerformed(true);
        globalThis.setTimeout(() => {
          setShowActionPerformed(false);
        }, 4000);
      }
    );
  }

  const handleConfirmCustomButtons = () => {
    confirm('Library confirm', 'Are you sure you want to perform this action?',
      () => {
        setShowActionPerformed(true);
        globalThis.setTimeout(() => {
          setShowActionPerformed(false);
        }, 4000);
      }, "Yes", "No"
    );
  }

  const handleConfirmCustomText = () => {
    confirm(<Box sx={{color:'blue'}}>Library confirm</Box>, 
      <>Are you sure you want to perform this <b>action?</b></>,
      () => {
        setShowActionPerformed(true);
        globalThis.setTimeout(() => {
          setShowActionPerformed(false);
        }, 4000);
      }
    );
  }

  return (
    <PageContainer
      heading='Other Samples - Alerts'
      icon={<MiscellaneousServicesIcon />}
      pageInfo={<OtherSamplesAlertsPageInfo />}
      wrapRightElementForMobile={false}
    >
      <PageDefaultSegment>
      <Box>
          The library has a built in alert.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="alert1"
            onClick={() => alert("Library alert", "This is some alert")}
          >
            Show alert
          </Button>

        </Box>

        <Box sx={{ marginTop: 4 }}>
          You can also change the OK text.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="alert2"
            onClick={() => alert("Library alert", "This is some alert", "Got it")}
          >
            Show alert
          </Button>

        </Box>

        <Box sx={{ marginTop: 4 }}>
          You can also use html styling for the title and text.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="alert3"
            onClick={() => alert(<Box sx={{color:'blue'}}>Library alert</Box>, <>This is some <b>alert</b></>, "Got it")}
          >
            Show alert
          </Button>

        </Box>

        <hr style={{ margin: '40px 0', borderTop: '1px solid rgb(220, 220, 220)' }} />

        <Box sx={{ marginTop: 4 }}>
          The library also has a built in confirm.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="confirm1"
            onClick={() => handleConfirm()}
          >
            Show confirm
          </Button>

        </Box>

        <Box sx={{ marginTop: 4 }}>
          You can also change the OK and Cancel text.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="confirm2"
            onClick={() => handleConfirmCustomButtons()}
          >
            Show confirm
          </Button>

        </Box>

        <Box sx={{ marginTop: 4 }}>
          You can also use html styling for the title and text.
        </Box>
        <Box sx={{ marginTop: 2 }}>

          <Button
            variant="contained"
            data-testid="confirm3"
            onClick={() => handleConfirmCustomText()}
          >
            Show confirm
          </Button>

        </Box>

        {showActionPerformed &&
          <Box data-testid="action-performed" sx={{
            marginTop: 4, border: '1px solid gray', borderRadius: 2,
            background: 'white', width: 200, padding: 2
          }}>
            You have confirmed
          </Box>
        }
      </PageDefaultSegment>
    </PageContainer>
  )
}
